import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'transflo-scheduler-no-auth',
  templateUrl: './scheduler-no-auth.component.html'
})
export class SchedulerNoAuthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
